import React from 'react'
import Editor from './editor'
import createReactClass from 'create-react-class'


var EditorContainer = createReactClass({
	render: function() {
		return (
			<Editor />
		);
	}
});

export default EditorContainer;
